
import React from "react";
import * as Material from "@mui/material";
import { IconChevronDown, IconX } from "@tabler/icons-react";
import { Button } from "@fragments";

export default function Filter({ name, valueLabel, onClick, icon, customComponent, className, onClear }) {
    return (
        <div className={`filter-item pressable ${className}`} onClick={(e) => {
            if (!customComponent) {
                onClick(e);
            }
        }}>
            {icon && <span className="filter-icon">{icon}</span>}
            <span>{name}</span>
            <Material.Divider orientation="vertical" flexItem />
            {
                customComponent ? customComponent : <span className="bold">{valueLabel}</span>
            }
            {onClear ? (
                <Button
                    icon={<IconX size={14} />}
                    color="overlay"
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation();
                        onClear();
                    }}
                />
            ) : (
                <IconChevronDown />
            )}
        </div>
    )
}
